"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPropertiesWithFieldMappings = void 0;
var CDP_BASEPROPS = [
    'appVersion',
    'product',
    'businessUnit',
    'component',
    'environmentName',
    'userId',
    'userGroup',
    'isCVIIUser',
    'platform'
];
/**
 * Reads field mappings from options to transform event properties
 * keys with the values from the field mappings data
 */
function transformPropertiesWithFieldMappings(data, options) {
    var _a;
    var prefix = 'cvent_';
    var fieldMappings = (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.fieldMappings;
    if (fieldMappings && data) {
        Object.keys(fieldMappings).forEach(function (key) {
            var actualKey = fieldMappings[key];
            if (!CDP_BASEPROPS.includes(actualKey)) {
                data[actualKey] = data[key];
                var keyWithPrefix = "".concat(prefix).concat(actualKey);
                if (data[keyWithPrefix]) {
                    data[keyWithPrefix] = data[key];
                    keyWithPrefix = "".concat(prefix).concat(key);
                    delete data[keyWithPrefix];
                }
                delete data[key];
            }
        });
    }
    return data;
}
exports.transformPropertiesWithFieldMappings = transformPropertiesWithFieldMappings;
